module.exports = __webpack_public_path__ + "img/0_b.575582fb.jpg";